/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetAgentSessionHistoryResult } from '../../models/get-agent-session-history-result';

export interface ApiSessionsSessionIdGet$Params {

/**
 * Session to read. Enough on its own — the agent comes from the session, and
 * access is decided by the caller's own token: an admin sees any session, a
 * session token only its own, a user only sessions in their space.
 */
  sessionId: string;

/**
 * Space to act in. Omit to use the user's default space. Must be a space the user belongs to, otherwise the request is rejected.
 */
  'x-space-id'?: string;
}

export function apiSessionsSessionIdGet(http: HttpClient, rootUrl: string, params: ApiSessionsSessionIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAgentSessionHistoryResult>> {
  const rb = new RequestBuilder(rootUrl, apiSessionsSessionIdGet.PATH, 'get');
  if (params) {
    rb.path('sessionId', params.sessionId, {});
    rb.header('x-space-id', params['x-space-id'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetAgentSessionHistoryResult>;
    })
  );
}

apiSessionsSessionIdGet.PATH = '/api/Sessions/{sessionId}';
